package content

import react.*
import react.dom.li
import styled.*

fun RBuilder.softwareDevelopmentContent(){
    styledH1 {
        css {
            +BaseLayoutStyles.noMarginNoPaddingNoBorders
        }
        attrs.text("Softwareentwicklung")
    }
    styledDiv {
        css {
            +BaseLayoutStyles.alignTextLeft
            +BaseLayoutStyles.noMarginNoPaddingNoBorders
        }
        styledP {

            +"Wir entwickeln Software bevorzugt in Java, Kotlin und C/C++."
        }
        styledP {
            +"Dabei sind wir uns bewusst darüber, dass jede Programmiersprache ihre Stärken und Schwächen hat, "
            +"die auch Einfluss auf den Entwicklungsprozess und den Aufbau der CI/CD Pipeline hat."
        }
        styledP {
            +"In der Entwicklung bevorzugen wir die Testgetriebene Arbeit nach Scrum. "
        }
        styledP {
            +"Unsere Mitarbeiter haben schon an einer Vielzahl unterschiedlichster Projekte mitgewirkt, wie der: "
            styledUl {
                li {
                    +"Analyse des Schwingungsverhaltens von Ventilatoren"
                }
                li {
                    +"Auslegung einer Foliendruckpresse"
                }
                li {
                    +"Entwicklung einer Echtzeitsteuerung für eine Foliendruckpresse"
                }
                li {
                    +"Entwicklung einer Echtzeitsteuerung für eine Linienschneidemaschine"
                }
                li {
                    +"Entwicklung einer automatischen Parameterbestimmung für PID-Regler"
                }
                li {
                    +"Entwicklung einer nahezu Bewegungslosen Kommutierung"
                }
                li {
                    +"Weiterentwicklung eines Linux-basierten Echtzeitsystems"
                }
                li {
                    +"Weiterentwicklung eines Konfigurations und Überwachungsprogramms für Umrichter"
                }
                li {
                    +"Weiterentwicklung für eine Beratersoftware für Versicherungsmakler (Online und Offline)"
                }
                li {
                    +"Entwicklung einer Android app zur Zeiterfassung"
                }
                li {
                    +"und andere"
                }
            }
        }
    }
}
